import client from "/src/services/client";

export default {
    getAllLogs: (params = {}) => client.get(`telephony/logs`, params),
};
